import {SiteState} from '../interfaces';

export const state: SiteState = {
  error: false,
  links: null,
  loading: false,
  name: '',
  customerId: '',
  enableBooking: false,
  slug: '',
  isDemo: false,
  motd: null,
  enableContact: false,
  enableFeedback: false,
  isOpenSelector: false,
  siteList: [],
  enableAffluence: false,
  affluenceZones: [],
  affluenceResponse: [],
  brandId: '',
  logo2: null,
  enableI18n: false,
};
